import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [{
    path: '/login',
    name: 'login',
    component: () => import('../components/Login.vue')
},
{
    path: '/',
    redirect: '/home'
},
]

// 需要通过后台数据来生成的组件
export const asyncRoutes = {
    'home': {
        path: 'home',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    "statistics": {
        path: 'statistics',
        name: 'statistics',
        component: () => import('../views/statistics.vue')
    },
    't1': {
        path: 't1',
        name: 't1',
        component: () => import('../views/T1.vue')
    },
    'password': {
        path: 'password',
        name: 'password',
        component: () => import('../views/Password.vue')
    },
    'msg': {
        path: 'msg',
        name: 'msg',
        component: () => import('../views/Msg.vue')
    },
    'userinfo': {
        path: 'userinfo',
        name: 'userinfo',
        component: () => import('../views/UserInfo.vue')
    },

    'statisticsNew1': {
        path: 'statisticsNew1',
        name: 'statisticsNew1',
        component: () => import('../views/statisticsNew1.vue')
    },
    'Notification': {
        path: 'Notification',
        name: 'Notification',
        component: () => import('../views/Notification.vue')
    },
    'jurisdiction': {
        path: 'jurisdiction',
        name: 'jurisdiction',
        component: () => import('../views/jurisdiction.vue')
    },
    'Award': {
        path: 'Award',
        name: 'Award',
        component: () => import('../views/Award.vue')
    },
    "ProductOrderNew": {
        path: 'ProductOrderNew',
        name: 'ProductOrderNew',
        component: () => import('../views/ProductOrderNew.vue')
    },
    "ProductUrlTmpl": {
        path: 'ProductUrlTmpl',
        name: 'ProductUrlTmpl',
        component: () => import('../views/ProductUrlTmpl.vue')
    },
    "ProductUrlParam": {
        path: 'ProductUrlParam',
        name: 'ProductUrlParam',
        component: () => import('../views/ProductUrlParam.vue')
    },
    "Administrator": {
        path: 'Administrator',
        name: 'Administrator',
        component: () => import('../views/Administrator.vue')
    },
    'JuniorOrderForm': {
        path: 'JuniorOrderForm',
        name: 'JuniorOrderForm',
        component: () => import('../views/JuniorOrderForm.vue')
    },
    'GroupConfig': {
        path: 'GroupConfig',
        name: 'GroupConfig',
        component: () => import('../views/GroupConfig.vue')
    },
    'Product': {
        path: 'Product',
        name: 'Product',
        component: () => import('../views/Product.vue')
    },
    'ExtractList': {
        path: 'ExtractList',
        name: 'ExtractList',
        component: () => import('../views/ExtractList.vue')
    },
    'ProductOrder': {
        path: 'ProductOrder',
        name: 'ProductOrder',
        component: () => import('../views/ProductOrder.vue')
    },
    'ProductUrl': {
        path: 'ProductUrl',
        name: 'ProductUrl',
        component: () => import('../views/ProductUrl.vue')
    },
    'Insurance': {
        path: 'Insurance',
        name: 'Insurance',
        component: () => import('../views/Insurance.vue')
    },
    'SystemArguments': {
        path: 'SystemArguments',
        name: 'SystemArguments',
        component: () => import('../views/SystemArguments.vue')
    },
    'DaKuan': {
        path: 'DaKuan',
        name: 'DaKuan',
        component: () => import('../views/DaKuan.vue')
    }, 'TeamStatistics': {
        path: 'TeamStatistics',
        name: 'TeamStatistics',
        component: () => import('../views/TeamStatistics.vue')
    }, 'OutsideGroupQueryList': {
        path: 'OutsideGroupQueryList',
        name: 'OutsideGroupQueryList',
        component: () => import('../views/OutsideGroupQueryList.vue')
    }, 'OutsideProductQueryList': {
        path: 'OutsideProductQueryList',
        name: 'OutsideProductQueryList',
        component: () => import('../views/OutsideProductQueryList.vue')
    }, 'OutsideOrderQueryList': {
        path: 'OutsideOrderQueryList',
        name: 'OutsideOrderQueryList',
        component: () => import('../views/OutsideOrderQueryList.vue')
    }, 'ProductGroupQueryList': {
        path: 'ProductGroupQueryList',
        name: 'ProductGroupQueryList',
        component: () => import('../views/ProductGroupQueryList.vue')
    }, 'QueryBindProductList': {
        path: 'QueryBindProductList',
        name: 'QueryBindProductList',
        component: () => import('../views/QueryBindProductList.vue')
    }, 'ProductNew': {
        path: 'ProductNew',
        name: 'ProductNew',
        component: () => import('../views/ProductNew.vue')
    }, 'UserGroupQueryList': {
        path: 'UserGroupQueryList',
        name: 'UserGroupQueryList',
        component: () => import('../views/UserGroupQueryList.vue')
    },

    'adminStatistics': {
        path: 'adminStatistics',
        name: 'adminStatistics',
        component: () => import('../views/adminStatistics.vue')
    },

    'template': {
        path: 'template',
        name: 'template',
        component: () => import('../views/Template.vue')
    },
    'record': {
        path: 'record',
        name: 'record',
        component: () => import('../views/Record.vue')
    },
    'ActivityList': {
        path: 'ActivityList',
        name: 'ActivityList',
        component: () => import('../views/ActivityList.vue')
    }, 'PopupsList': {
        path: 'PopupsList',
        name: 'PopupsList',
        component: () => import('../views/PopupsList.vue')
    }, 'DataRecording': {
        path: 'DataRecording',
        name: 'DataRecording',
        component: () => import('../views/DataRecording.vue')
    }, 'Excel': {
        path: 'Excel',
        name: 'Excel',
        component: () => import('../views/Excel.vue')
    }, 'ProductUrlGroupList': {
        path: 'ProductUrlGroupList',
        name: 'ProductUrlGroupList',
        component: () => import('../views/ProductUrlGroupList.vue')
    },
    'ProductShieldUser': {
        path: 'ProductShieldUser',
        name: 'ProductShieldUser',
        component: () => import('../views/ProductShieldUser.vue')
    },
    'GiftManagement': {
        path: 'GiftManagement',
        name: 'GiftManagement',
        component: () => import('../views/GiftManagement.vue')
    },
    'InformationGift': {
        path: 'InformationGift',
        name: 'InformationGift',
        component: () => import('../views/InformationGift.vue')
    },
    'BlacklistQueryList': {
        path: 'BlacklistQueryList',
        name: 'BlacklistQueryList',
        component: () => import('../views/BlacklistQueryList.vue')
    },


}

const createRouter = () => new Router({
    routes: commonRoutes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router